import React, { useState } from 'react';
import { Header } from './components/Header';
import { SubscriptionOverview } from './components/SubscriptionOverview';
import { RegionSelector } from './components/RegionSelector';
import { PaymentMethods } from './components/PaymentMethods';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SuccessScreen } from './components/SuccessScreen';
export function App() {
  const [selectedRegion, setSelectedRegion] = useState('Nigeria');
  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const handlePaymentSuccess = () => {
    setShowSuccessScreen(true);
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      {showSuccessScreen ? <SuccessScreen onBackToHome={() => setShowSuccessScreen(false)} data-id="element-1" /> : <div className="max-w-3xl mx-auto px-4 py-8" data-id="element-2">
          <Header data-id="element-3" />
          <main className="space-y-8" data-id="element-4">
            <SubscriptionOverview data-id="element-5" />
            <RegionSelector selectedRegion={selectedRegion} onRegionChange={setSelectedRegion} data-id="element-6" />
            <PaymentMethods selectedRegion={selectedRegion} onPaymentSuccess={handlePaymentSuccess} data-id="element-7" />
            <FAQ data-id="element-8" />
          </main>
          <Footer data-id="element-9" />
        </div>}
    </div>;
}